import { Component, ElementRef, HostListener, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { environment } from 'environments/environment';
import { ConstantsService } from 'app/services/constants-service';

import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  templateUrl: './entity-transaction-profile.component.html'
})

export class EntityTransactionProfileComponent implements OnInit, OnDestroy {
  entityIdDetails: EntityIdDetails;
  private subscriptions: Subscription[] = [];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public entityDetailsService: EntityDetailsService) {
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();
    const subscription = this.entityDetailsService.entityDetailsUpdated.subscribe(
      (entityDetails) => {
        this.entityIdDetails = entityDetails;
      }
    );
    this.subscriptions.push(subscription);
  }

  ngOnDestroy() {
    // Unsubscribe from all subscriptions to prevent memory leaks and duplicate calls
    this.subscriptions.forEach(sub => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/entity-transaction-profile.component.ts